import Form from 'react-bootstrap/Form'
import MutedText from 'shared/forms/muted-text'

function PoBox({ params, setParams }) {
  const checked = params.po_box === true
  return (
    <>
      <Form.Check
        inline
        checked={checked}
        label="PO Box Address"
        name="po-box-vendors"
        type={'checkbox'}
        onChange={() =>
          setParams({ ...params, po_box: !params.po_box })
        }
        id={'po-box-vendors-checkbox'}
      />
      <MutedText as="div" className="ms-4">
        Vendor's main address is a PO Box
      </MutedText>
    </>
  )
}

export default PoBox
